import React from 'react';

function SubscribeRequired({ size }) {
  return (
    <p className={`subscribe-${size}-message`}>All fields are required</p>
  );
}

export default SubscribeRequired;
